import { render, staticRenderFns } from "./ModalHistoryReview.vue?vue&type=template&id=f4698f66&"
import script from "./ModalHistoryReview.vue?vue&type=script&lang=js&"
export * from "./ModalHistoryReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports